import { create } from 'zustand'
import type { ToastMessage } from '@/components/overlays'

let nextId = 1

interface ToastStore {
  toasts: ToastMessage[]
  push: (title: string, tone?: ToastMessage['tone']) => void
  dismiss: (id: number) => void
}

export const useToasts = create<ToastStore>((set) => ({
  toasts: [],
  push: (title, tone = 'neutral') =>
    set((state) => ({ toasts: [...state.toasts, { id: nextId++, title, tone }] })),
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}))
